import { email, helpers } from '@vuelidate/validators'

export const emailValidator = helpers.withMessage(
  'No es una dirección de correo electrónico válida',
  email
)
